module.exports = __webpack_public_path__ + "media/images/lb/304-c8d8e960a9effe28438b35f96fbd9bc0.svg";